import * as React from "react";
import {useEffect, useState} from "react";
import {Alert, Button} from "react-bootstrap";
import ImageComponent from "./ImageComponent";
import {populateImageUrl} from "../service/ImageService";
import {downloadImagesAsZip} from "../lib/downloadImagesZip";


export default function JobImageGallary(props) {
    const {job, isReadOnly, images, setImages} = props

    const [isLoading, setIsLoading] = useState(false)
    const [isDownloadingAll, setIsDownloadingAll] = useState(false)
    const [downloadError, setDownloadError] = useState("")


    // Function to delete an image by id
    const deleteImage = (id) => {
        // Filter out the image with the specific id
        const updatedImages = images.filter(image => image.id !== id);
        // Update the state with the new array of images
        setImages(updatedImages);
    };

    function isUrlExpired(url) {
        if (!url) return true;
        const params = new URLSearchParams(url.split('?')[1]);
        const expireSeconds = parseInt(params.get('X-Goog-Expires'), 10);
        const startTime = params.get('X-Goog-Date');

        const year = startTime.slice(0, 4);
        const month = startTime.slice(4, 6);
        const day = startTime.slice(6, 8);
        const hour = startTime.slice(9, 11);
        const minute = startTime.slice(11, 13);
        const second = startTime.slice(13, 15);

        const isoString = `${year}-${month}-${day}T${hour}:${minute}:${second}Z`;
        const startDate = new Date(isoString);

        //Start time plus expire seconds
        startDate.setSeconds(startDate.getSeconds() + expireSeconds);
        return new Date() > startDate;
    }

    // useEffect(() => {
    //     let changedImages = []
    //     images?.forEach((image) => {
    //         if (isUrlExpired(image.downloadUrl)) {
    //             changedImages.push({
    //                 ...image,
    //                 downloadUrl: undefined,
    //                 thumbnailUrl: undefined
    //             })
    //         }
    //     })
    //     if (changedImages.length > 0) {
    //         // dispatch(updateImageInQuote({
    //         //     agentId: selectedUser.id,
    //         //     images: changedImages
    //         // }))
    //     }
    // }, [])


    useEffect(() => {
        setIsLoading(true)
        populateImageUrl(job.cos_job_id).then(async (imagesResponse) => {
            if (imagesResponse.status === 200) {
                imagesResponse.json().then((data) => {
                    setImages(data)
                })
            }
        }).finally(() => setIsLoading(false))

    }, [job])

    const imageSize = 100

    async function handleDownloadAll() {
        if (!images?.length) {
            return;
        }

        setDownloadError("");
        setIsDownloadingAll(true);

        try {
            await downloadImagesAsZip(job, images);
        } catch (error) {
            console.error("Failed to download all images", error);
            setDownloadError("Unable to download all images.");
        } finally {
            setIsDownloadingAll(false);
        }
    }

    return (
        <div>
            <div style={{display: "flex", justifyContent: "flex-end", marginTop: "10px"}}>
                <Button
                    variant="outline-secondary"
                    disabled={isLoading || isDownloadingAll || !images?.length}
                    onClick={handleDownloadAll}
                >
                    {isDownloadingAll ? "Downloading..." : "Download all"}
                </Button>
            </div>
            {downloadError ? (
                <Alert variant="danger" className="mt-2 mb-0">
                    {downloadError}
                </Alert>
            ) : null}
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center'
            }}>
                {isLoading && <div>Loading Images... <img width={"100px"} src={"/loading.gif"}/></div>}

                {images && images.map((item, index) => (
                    <ImageComponent
                        key={index + item.id}
                        isReadOnly={isReadOnly}
                        item={item}
                        alt={item.title}
                        loading="lazy"
                        width={imageSize}
                        height={imageSize}
                        deleteImage={deleteImage}

                    />

                ))}
            </div>
        </div>

    )
}
